<template>

</template>

<script>
export default {
  name: 'SignUpDriver',
  data: function () {
    return {
      mounted: false,
    }
  },
  computed: {
    ready: function() {
      return this.mounted && this.$auth.auth0Client;
    }
  },
  mounted() {
    this.mounted = true;
  },
  watch: {
    ready: function(newValue) {
      if (newValue) {
        this.signUp();
      }
    }
  },
  methods: {
    signUp() {
      this.$auth.loginWithRedirect({
        authorizationParams: {
          screen_hint: "signup",
        },
        appState: {
          targetUrl: `after-auth?from=sign-up-driver`,
        },
      });
    },
  },
}
</script>
